module.exports = __webpack_public_path__ + "img/oida.svart.duplet.fd5327a7.png";